module.exports = __webpack_public_path__ + "img/phoneEle.39007f92.svg";